<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'">{{aLang.c_create}} liên hệ</span>
        <span v-if="mData.viewMode == 'update'">{{aLang.c_update}} liên hệ</span>
        <span v-if="mData.viewMode == 'detail'">{{aLang.c_detail}} liên hệ</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="4">
              <el-form-item label="Họ tên" prop="ho_ten">
                <el-input
                  v-model="mData.dataForm.ho_ten"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Số điện thoại" prop="sdt">
                <el-input
                  v-model="mData.dataForm.sdt"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Email" prop="email">
                <el-input
                  v-model="mData.dataForm.email"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="2">
              <el-form-item label="Xử lý" prop="xu_ly">
                <el-select
                  v-model="mData.dataForm.xu_ly"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listXuLy"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <!-- <b-col md="4">
              <el-form-item label="Tên công ty" prop="ten_cong_ty">
                <el-input
                  v-model="mData.dataForm.ten_cong_ty"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="4">
              <el-form-item label="Phòng ban" prop="phong_ban">
                <el-input
                  v-model="mData.dataForm.phong_ban"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col> -->
          </b-row>
          <b-row>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="noi_dung">
                <el-input 
                  v-model="mData.dataForm.noi_dung"
                  :disabled="mData.viewMode == 'detail'"
                  type="textarea"
                  rows="2"
                ></el-input>
                <!-- <CknoimgComponent
                  v-model="mData.dataForm.noi_dung"
                  :prop-data-editor-disabled="mData.viewMode == 'detail'"
                  @blur="handleBlur('noi_dung')"
                ></CknoimgComponent> -->
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <!-- <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
            >{{aLang.c_create}}</el-button> -->

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
            >{{aLang.c_update}}</el-button>

            <el-button @click="fn_go()" type="info" plain>{{aLang.c_back}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from '../../../service/LanguageService';
import MethodService from '../../../service/MethodService';
import LienHeModel from './LienHeModel';
import LienHeApi from '../../../moduleApi/LienHeApi';
import CknoimgComponent from "../../../component/CknoimgComponent";
export default {
  components: {
    CknoimgComponent
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "LienHe",
        dataDefault: {
          listXuLy: [
            {
              value: true,
              label: 'Đã xử lý'
            },
            {
              value: false,
              label: 'Chưa xử lý'
            }
          ]
        },
        dataForm: MethodService.copyObject(LienHeModel.dataForm),
        validForm: LienHeModel.validForm,
      },
    };
  },
  created() {
    // this.fn_initDataDefault();

    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "update") {
            data.id = this.$router.currentRoute.params.id;
            await LienHeApi.update(data);
           this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(
        LienHeModel.dataForm
      );

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let lien_he = await LienHeApi.findById(id);
      if (lien_he.result) {
        this.mData.dataForm = lien_he.result;
      }
    },

    fn_go() {
      this.$router.go(-1);
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    }
  }
}
</script>

<style>

</style>
